import { Pipe, PipeTransform } from '@angular/core';

import { pedidoReferenciasData } from '../pedido-referencia-data';

@Pipe({
    name: 'pedidoReferenciaDataIcon'
})
export class PedidoReferenciaDataIconPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = pedidoReferenciasData.findIndex(ref => ref.id === value);
        if (index > -1) {
            return pedidoReferenciasData[index].iconClass;
        }
        return '';
    }
}
